import React, { useState, useEffect } from 'react';
import {
  InputGrid,
  useResponsiveParams,
  Text,
  useQuantaFormikContext,
  NotificationList,
} from 'quanta-ui';
import CancelModal from '../risk_location/cancel-modal';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import { useFetchQuery } from 'quanta-flows';
import { 
  PINCODE_LOOKUP,
  PINCODE_EXCLUSION_LIST
 } from '../../queries';
 import { init_state_quote,updateFireQuote } from 'quanta-flows/modules/quote/fire/state'; //new
//import (PINCODE_LOOKUP)
export default function PolicyDetails({
  PRD_policyPeriod,
  PRD_typeOfPolicy,
  PRD_basisOfValuation,
  PRD_geographicalArea,
  PRD_costOfConstruction,
  productCode,
  fireQuote,
  minDay,
  role,
}) {
  const isQuoteReadOnly =
    [
      'quote saved',
      'underwriter approved',
      'underwriter rejected',
      'converted to proposal',
    ]?.includes(fireQuote?.status?.toString()?.toLowerCase()) ||
    (role?.toString()?.toLowerCase() !== 'underwriter' &&
      fireQuote?.status?.toString()?.toLowerCase() ===
        'pending uw approval');
        const [loadingPermCustAddr, setLoadingPermCustAddr] =
        useState(false);
  const { values, setFieldValue } = useQuantaFormikContext();
  const [alerts, setAlerts] = useState([]);
  const [selectedValue, setSelectedValue] = useState('');
  const [showCancelModal, setShowCancelModal] = useState(false);
  const fetchQuery = useFetchQuery();
  const onPermAddrLookup = async (val, setFieldValue) => {
    if (val?.length === 6 && val?.match(/^[0-9]+$/)) {
      try {
        let pinCodeExlQuery = fetchQuery({
          query: PINCODE_EXCLUSION_LIST,
          fetchPolicy:'network-only',
          variables: {
            productCode: productCode?.toString()
          },
        });
        setAlerts([]);
        setLoadingPermCustAddr(true);
        //setChangeDisabled(true);
        let { data : pinCodeExlData} = await pinCodeExlQuery;
        if( pinCodeExlData?.getPincodeExclList?.find((e) => e?.pincodeDetails?.pincode?.toString() === val?.toString())){
          throw new Error("Pincode Restricted" );
        }
        setLoadingPermCustAddr(false);
        let queryOutput = fetchQuery({
          query: PINCODE_LOOKUP,
          variables: {
            filter: {
              pincode: val,
            },
          },
        });
        setAlerts([]);
        setLoadingPermCustAddr(true);
        //setChangeDisabled(true);
        let { data } = await queryOutput;
        setLoadingPermCustAddr(false);
        //setChangeDisabled(false);
        if (!data?.pincodeWithEqZone) {
          setAlerts([
            {
              header: 'Address fetch failed',
              id: parseInt(uuidv4()),
              content: (
                <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                  <span>{'Invalid Pincode'}</span>
                </div>
              ),
              type: 'error',
              timeout: null,
              disableClose: false,
            },
          ]);
          setFieldValue(
            `riskLocations.addressDetails.state`,
            '',
          );
          setFieldValue(
            `riskLocations.addressDetails.district`,
            '',
          );
          // setFieldValue(
          //   `riskLocations.stockLocations[0].state`,
          //   '',
          // );
          // setFieldValue(
          //   `riskLocations.stockLocations[0].district`,
          //   '',
          // );
          // setFieldValue(
          //   `riskLocations.stockLocations[0].eqZone`,
          //   '',
          // );
          // setFieldValue(
          //   `riskLocations.stockLocations[0].locationCode`,
          //   '',
          // );
          // setFieldValue(
          //   `riskLocations.stockLocations[0].locationDesc`,
          //   '',
          // );
          window?.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
          setFieldValue(
            `riskLocations.addressDetails.state`,
            data?.pincodeWithEqZone?.state
              ? `${data?.pincodeWithEqZone?.state}`
              : '',
          );
          setFieldValue(
            `riskLocations.addressDetails.district`,
            data?.pincodeWithEqZone?.district
              ? `${data?.pincodeWithEqZone?.district}`
              : '',
          );
          setFieldValue(
            `riskLocations.addressDetails.eqZone`,
            data?.pincodeWithEqZone?.eqZone
              ? `${data?.pincodeWithEqZone?.eqZone}`
              : '',
          );
          updateFireQuote({ //new
            eqZone:data?.pincodeWithEqZone?.eqZone,
            locationCode:data?.pincodeWithEqZone?.locationCode,
            pinCodeLocality:data?.pincodeWithEqZone?.pinCodeLocality,
            city:data?.pincodeWithEqZone?.city,
          
          
        });
          // setFieldValue(
          //   `riskLocations.addressDetails.eqZone`,
          //   data?.pincodeWithEqZone?.eqZone
          //     ? `${data?.pincodeWithEqZone?.eqZone}`
          //     : '',
          // );
          // setFieldValue(
          //   `riskLocations.addressDetails.locationCode`,
          //   data?.pincodeWithEqZone?.locationCode
          //     ? `${data?.pincodeWithEqZone?.locationCode}`
          //     : '',
          // );
          // setFieldValue(
          //   `riskLocations.addressDetails.locationDesc`,
          //   data?.pincodeWithEqZone?.locationDesc
          //     ? `${data?.pincodeWithEqZone?.locationDesc}`
          //     : '',
          // );
          // setFieldValue(
          //   `riskLocations.stockLocations[0].state`,
          //   data?.pincodeWithEqZone?.state
          //     ? `${data?.pincodeWithEqZone?.state}`
          //     : '',
          // );
          // setFieldValue(
          //   `riskLocations.stockLocations[0].district`,
          //   data?.pincodeWithEqZone?.district
          //     ? `${data?.pincodeWithEqZone?.district}`
          //     : '',
          // );
          // setFieldValue(
          //   `riskLocations[${riskLocationIndex}].stockLocations[0].eqZone`,
          //   data?.pincodeWithEqZone?.eqZone
          //     ? `${data?.pincodeWithEqZone?.eqZone}`
          //     : '',
          // );
          // setFieldValue(
          //   `riskLocations.stockLocations[0].locationCode`,
          //   data?.pincodeWithEqZone?.locationCode
          //     ? `${data?.pincodeWithEqZone?.locationCode}`
          //     : '',
          // );
          // setFieldValue(
          //   `riskLocations.stockLocations[0].locationDesc`,
          //   data?.pincodeWithEqZone?.locationDesc
          //     ? `${data?.pincodeWithEqZone?.locationDesc}`
          //     : '',
          // );
        }
      } catch (error) {
        setAlerts([
          {
            header: 'Address fetch failed',
            id: parseInt(uuidv4()),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>{error?.message}</span>
              </div>
            ),
            type: 'error',
            timeout: null,
            disableClose: false,
          },
        ]);
        setLoadingPermCustAddr(false);
        //setChangeDisabled(false);
        setFieldValue(
          `riskLocations.addressDetails.state`,
          '',
        );
        setFieldValue(
          `riskLocations.addressDetails.district`,
          '',
        );
        setFieldValue(
          `riskLocations.addressDetails.eqZone`,
          ''
        );
        // setFieldValue(
        //   `riskLocations.stockLocations[0].state`,
        //   '',
        // );
        // setFieldValue(
        //   `riskLocations.stockLocations[0].district`,
        //   '',
        // );
        // setFieldValue(
        //   `riskLocations.stockLocations[0].eqZone`,
        //   '',
        // );
        // setFieldValue(
        //   `riskLocations.stockLocations[0].locationCode`,
        //   '',
        // );
        // setFieldValue(
        //   `riskLocations.stockLocations[0].locationDesc`,
        //   '',
        // );
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }
  };

  const handleSelect = (e) => {
    //// console.log(e);
    setSelectedValue(e)
  }
  const noOfColsMobile = 1,
    noOfColsDesktop = 3;

  let inputColSpans = useResponsiveParams({
    for_mobile: noOfColsMobile,
    for_desktop: noOfColsDesktop,
  });
  useEffect(() => {
    // console.log("useeffect", values);
    if (
      values?.customerDetails?.customerType?.value
      ?.toString()
      ?.toLowerCase() ===  'housing society'
      
    ) {
      setFieldValue(
        `policyTypeDetails.tenure.code`,
        `1`,
      );
    }
  },
    
    
     
     [
    values?.customerDetails?.customerType?.value,
    // values?.riskLocations?.riskSumInsured?.additionalStructure,

  ]);

  let grid_data = [
    // {
    //   type: 'radiogroup',
    //   label: (
    //     <>
    //       Do you want this insurance for Kutcha Construction?
    //       <Text severity="error"> *</Text>
    //     </>
    //   ),
    //   colSpan: inputColSpans,
    //   name: 'policyTypeDetails.isInsuranceForKutchaConstruction',
    //   disabledGlobal: fireQuote?.status?.toString()?.toLowerCase() === 'quote saved',
    //   data: [
    //     {
    //       label: 'Yes',
    //       value: 'Yes',
    //     },
    //     {
    //       label: 'No',
    //       value: 'No',
    //     },
    //   ],
    // },
    {
      type: 'select',
      size: 'full',
      disableSelect: true,
      disabled: isQuoteReadOnly,
      label: (
        <>
          Policy/Cover Type<Text severity="error"> *</Text>
        </>
      ),
      name: 'policyTypeDetails.policyOrCoverType.code',
      data: PRD_typeOfPolicy
        ? [
            ...PRD_typeOfPolicy.map((policyType) => {
              return {
                label: policyType.value ? policyType.value : '',
                value: policyType.code ? policyType.code : '',
              };
            }),
          ]
        : [],
      onDataChange: (val, setFieldValue) => {
        // setFieldValue(
        //   `policyTenureValue`,
        //   PRD_PreviousPolicyTermList?.find(
        //     (pT) => pT?.code?.toLowerCase() === val?.toLowerCase(),
        //   )?.value,
        // );
        if (
          fireQuote?.quoteNumber &&
          fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.policyOrCoverType?.code
            ?.toString()
            ?.toLowerCase() !== val?.toString()?.toLowerCase()
        ) {
          setFieldValue(
            'policyTypeDetails.policyOrCoverType.value',
            PRD_typeOfPolicy?.find(
              (policyType) =>
                policyType?.code?.toString()?.toLowerCase() ===
                val?.toString()?.toLowerCase(),
            )?.value,
          );
          setShowCancelModal(true);
        } else {
          setFieldValue(
            'policyTypeDetails.policyOrCoverType.value',
            PRD_typeOfPolicy?.find(
              (policyType) =>
                policyType?.code?.toString()?.toLowerCase() ===
                val?.toString()?.toLowerCase(),
            )?.value,
          );
        }
      },
      onCompleted: (data) => {
        setPolicyTermList(data);
        if (productCode?.toString() === '1132' && values.domainCode?.toString() === 'Home Building Only') { setFieldValue(`basisOfValuation`,); }
      },
    },
    (values?.policyTypeDetails.policyOrCoverType.value?.toString() === 'Home Building Only' || values?.policyTypeDetails.policyOrCoverType.value?.toString() === 'Home Building And Home Contents'
    ) ?
      {
        type: 'select',
        label: (
          <> Basis of Valuation<Text severity="error"> *</Text>
          </>
        ),
        name: 'basisOfValuation',
        disabled: true,
        // false,
        data: [{
          label: 'Reinstatement value',
          value: 'Reinstatement value',
        },
        {
          label: 'Agreed Value',
          value: 'Agreed Value',
        },
        ],
        onDataChange: (val, setFieldValue) => {
        },
      } : null,
    {
      type: 'select',
      size: 'full',
      disableSelect: true,
      disabled: isQuoteReadOnly || 
      values?.customerDetails?.customerType?.value
      ?.toString()
      ?.toLowerCase() ===  'housing society',
      label: (
        <>
          Tenure<Text severity="error"> *</Text>
        </>
      ),
      name: 'policyTypeDetails.tenure.code',
      data: PRD_policyPeriod
        ? [
            ...PRD_policyPeriod.map((policyPeriod) => {
              return {
                label: `${policyPeriod.value} year`
                  ? `${policyPeriod.value} year`
                  : '',
                value: policyPeriod.code ? policyPeriod.code : '',
              };
            }),
          ]
        : [],
      onDataChange: (val, _) => {
        setFieldValue(
          'policyTypeDetails.tenure.value',
          PRD_policyPeriod?.find(
            (policyPeriod) =>
              policyPeriod?.code?.toString()?.toLowerCase() ===
              val?.toString()?.toLowerCase(),
          )?.value,
        );
      },
    },
    {
      type: 'date',
      size: 'full',
      disabled: isQuoteReadOnly,
      minDate: minDay,
      label: (
        <>
          Policy Start Date<Text severity="error"> *</Text>
        </>
      ),
      name: 'policyTypeDetails.policyStartDate',
      calendarPosition: 'top',
    },
    // {
    //   type: 'select',
    //   size: 'large',
      
    //   disabled: isQuoteReadOnly||
    //   values?.policyTypeDetails?.policyOrCoverType?.value
    //   ?.toString()
    //   ?.toLowerCase() ===  'home contents only', 
    //   label: (
    //     <>
    //      Geographical Area<Text severity="error"> *</Text>
    //     </>
    //   ),
    //   name: 'policyTypeDetails.geographicalArea.code',
    //   data: PRD_geographicalArea
    //     ? [
    //         ...PRD_geographicalArea.map((geoArea) => {
    //           return {
    //             label: geoArea.value ? geoArea.value : '',
    //             value: geoArea.code ? geoArea.code : '',
    //           };
    //         }),
    //       ]
    //     : [],
    //   onDataChange: (val, _) => {
    //    //console.log("inside ondatachange : val",val);
    //    if (
    //     fireQuote?.quoteNumber &&
    //     fireQuote?.tabDetails?.customerTabDetails?.policyTypeDetails?.geoArea?.code
    //       ?.toString()
    //       ?.toLowerCase() !== val?.toString()?.toLowerCase()
    //   ) {
    //     setFieldValue(
    //       'policyTypeDetails.geographicalArea.value',
    //       PRD_geographicalArea?.find(
    //         (geoArea) =>
    //           geoArea?.code?.toString()?.toLowerCase() ===
    //           val?.toString()?.toLowerCase(),
    //       )?.value,
    //     );
    //   } else {
    //     setFieldValue(
    //       'policyTypeDetails.geographicalArea.value',
    //       PRD_geographicalArea?.find(
    //         (geoArea) =>
    //           geoArea?.code?.toString()?.toLowerCase() ===
    //           val?.toString()?.toLowerCase(),
    //       )?.value,
    //     );
    //   }
    //   },
    // }
    // :null,
    {
      type: 'input-lookup',
      size: 'full',
      onLookup: onPermAddrLookup,
      loading: loadingPermCustAddr,
      disabled:
        loadingPermCustAddr ||
        isQuoteReadOnly,
      name: `riskLocations.addressDetails.pincode`,
      label: (
        <Text type={'label'}>
          Pin Code <Text severity={'error'}>*</Text>
        </Text>
      ),
      onDataChange: (val, setFieldValue) => {
        setFieldValue(
          `riskLocations.isLocationSaved`,
          false,
        );

        setFieldValue(
          `riskLocations.addressDetails.state`,
          '',
        );
        setFieldValue(
          `riskLocations.addressDetails.district`,
          '',
        );
        setFieldValue(
          `riskLocations.addressDetails.eqZone`,
          '',
        );
      },
      onKeyDown: (e) => {
        if (
          !e.key.match(/^[0-9]+$/) &&
          !['arrowleft', 'arrowright', 'backspace']?.includes(
            e?.key?.toString()?.toLowerCase(),
          )
        ) {
          e.preventDefault();
      }
      },
    },
    {
      type: 'text',
      size: 'full',
      name: `riskLocations.addressDetails.state`,
      disabled: true,
      label: (
        <Text type={'label'}>
          State <Text severity={'error'}>*</Text>
        </Text>
      ),
    },
    {
      type: 'text',
      size: 'full',
      name: `riskLocations.addressDetails.district`,
      disabled: true,
      label: (
        <Text type={'label'}>
          District <Text severity={'error'}>*</Text>
        </Text>
      ),
    },
  ].filter((d) => d);

  return (
    <>
      <InputGrid
        data={grid_data}
        repeat={inputColSpans}
        titleType="title"
        titleSeverity="info"
        size="large"
        gapX={10}
      />
      <div>
        <NotificationList {...{ items: alerts }} />
      </div>
      <div>
        <CancelModal
          onCancelClick={() => {
            setFieldValue(
              'policyTypeDetails.policyOrCoverType.code',
              fireQuote?.tabDetails?.customerTabDetails
                ?.policyTypeDetails?.policyOrCoverType?.code,
            );
            setFieldValue(
              'policyTypeDetails.policyOrCoverType.value',
              fireQuote?.tabDetails?.customerTabDetails
                ?.policyTypeDetails?.policyOrCoverType?.value,
            );
          }}
          cancelTitle={'Confirm Changes'}
          cancelText={
            <Text className="flex flex-col w-full space-y-2">
              <Text>Are you sure you want to Proceed ?</Text>
              <Text className="flex flex-row items-center space-x-1">
                <Text
                  className="font-semibold"
                  severity={'warning'}
                  type={'label'}
                >
                  Note :
                </Text>
                <Text type="label">
                  This will override changes made for previously
                  selected policy type
                </Text>
              </Text>
            </Text>
          }
          setShowCancelModal={setShowCancelModal}
          showCancelModal={showCancelModal}
        />
      </div>
    </>
  );
}
